import React, { useEffect } from 'react';
import styled from 'styled-components';
import Container from '@components/Container';
import Card from '@components/Card';
import Button from '@components/Button';
import { H2, P } from '@components/Parts';
import { useParams } from 'react-router-dom';
import { useApp } from '@contexts/app';
import HuddleImage from './HuddleImage';
import { useProduct } from '@contexts/product';
import AppLinks from '@components/AppLinks';
import useRedirect from '@hooks/useRedirect';
import { FLOWS } from '../../../../types/types.d';

// Temporary abbrv until we support different images
const HUDDLE_IMAGE_ABBRV = 'huddle';

const {
	REACT_APP_SUPERETTAN_HIGHLIGHTS_URL,
	REACT_APP_ALLSVENSKAN_HIGHLIGHTS_URL,
	REACT_APP_MY_PAGE_URL,
	REACT_APP_FOTBOLL_PLAY_URL,
} = process.env;

const Email = styled.a`
	color: ${(props) => props.theme.accent};
`;

const Header = styled(H2)`
	color: ${(props) => props.theme.accent};
	text-align: center;
`;

const Text = styled(P)`
	margin-top: 2px;
	margin-bottom: 0;
	text-align: center;
`;

export const Box = styled.div`
	display: flex;
	justify-content: center;
	align-self: stretch;
	flex-direction: column;
	margin-bottom: 16px;
	@media (max-width: 732px) {
		flex-direction: column;
	}
`;

export const Spacing = styled.div`
	height: 20px;
`;

function ThankYouPage(): JSX.Element {
	const { abbrv = '' } = useParams<{
		abbrv: string;
	}>();
	const { person } = useApp();
	const { product, redirectUrl } = useProduct();
	const { redirectIfMissingProduct } = useRedirect();

	useEffect(() => {
		redirectIfMissingProduct(FLOWS.SUBSCRIPTION, product);
	}, [product, redirectIfMissingProduct]);

	function handleAppLinkClick(type: 'allsvenskan' | 'superettan') {
		if (type === 'allsvenskan') {
			window.location.href = `${REACT_APP_ALLSVENSKAN_HIGHLIGHTS_URL}?rs=1`;
		} else if (type === 'superettan') {
			window.location.href = `${REACT_APP_SUPERETTAN_HIGHLIGHTS_URL}?rs=1`;
		}
	}

	function handleFotbollPlayClick() {
		window.location.href = redirectUrl || (REACT_APP_FOTBOLL_PLAY_URL as string);
	}

	function handleMyPageClick() {
		window.location.href = REACT_APP_MY_PAGE_URL as string;
	}

	return (
		<Container role="document" className="ThankYouPage">
			<HuddleImage aria-label="Tack!" abbrv={HUDDLE_IMAGE_ABBRV} />
			<Card contentMaxWidth={632} paddingTop={60} paddingBottom={40}>
				<Header>
					Tack för ditt abonnemang
					{`${
						person?.GivenName && person.GivenName !== ' ' ? ` ${person.GivenName}` : ''
					}`}
					!
					<br />
				</Header>
				<Text>
					Du kan även hantera ditt abonnemang på Mina Sidor i ditt{' '}
					<Email href={REACT_APP_MY_PAGE_URL}>Fotbollskonto</Email>.
				</Text>
			</Card>

			<Card contentMaxWidth={676} paddingBottom={40}>
				<Box>
					<Button callToAction name="fotboll-play" action={handleFotbollPlayClick}>
						Tillbaka till Fotboll Play
					</Button>
					<Spacing />
					<Button name="my-page" action={handleMyPageClick}>
						Fortsätt till Mina Sidor
					</Button>
				</Box>
				<AppLinks action={handleAppLinkClick} />
			</Card>
		</Container>
	);
}

export default ThankYouPage;
